import { registerQuery, useQuery } from 'data-fetching-client';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
const serviceCatalogPublicClient = promiseClient(createStack(coreMiddlewares.base('service-catalog/public/v1/'), noAuthStack));
const GET_CATALOG_SERVICES = registerQuery({
  fieldName: 'catalogServices',
  args: [],
  fetcher() {
    return serviceCatalogPublicClient.get('services');
  }
});
export function useGetCatalogServices({
  skip
}) {
  const {
    data,
    loading
  } = useQuery(GET_CATALOG_SERVICES, {
    skip
  });
  return {
    catalogServices: data === null || data === void 0 ? void 0 : data.catalogServices,
    loading
  };
}